/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { UsersAuthzDenyPermissionToGroupManagedPermissionsMutationResponse, UsersAuthzDenyPermissionToGroupManagedPermissionsPathParams, UsersAuthzDenyPermissionToGroupManagedPermissions401, UsersAuthzDenyPermissionToGroupManagedPermissions403 } from "../models/UsersAuthzDenyPermissionToGroupManagedPermissions";

export function getUsersAuthzDenyPermissionToGroupManagedPermissionsUrl(groupId: UsersAuthzDenyPermissionToGroupManagedPermissionsPathParams["groupId"], permission: UsersAuthzDenyPermissionToGroupManagedPermissionsPathParams["permission"]) {
  const res = { method: 'POST', url: `/users-authz/v1/groups/${groupId}/permissions/${permission}/deny` as const }
  return res
}

/**
 * @description Requires CLIENT_ADMIN role or client API key
 * @summary Deny a permission for a group
 * {@link /users-authz/v1/groups/:groupId/permissions/:permission/deny}
 */
export async function usersAuthzDenyPermissionToGroupManagedPermissions(groupId: UsersAuthzDenyPermissionToGroupManagedPermissionsPathParams["groupId"], permission: UsersAuthzDenyPermissionToGroupManagedPermissionsPathParams["permission"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<UsersAuthzDenyPermissionToGroupManagedPermissionsMutationResponse, ResponseErrorConfig<UsersAuthzDenyPermissionToGroupManagedPermissions401 | UsersAuthzDenyPermissionToGroupManagedPermissions403>, unknown>({ method : "POST", url : getUsersAuthzDenyPermissionToGroupManagedPermissionsUrl(groupId, permission).url.toString(), ... requestConfig })
  return res.data
}